module.exports = __webpack_public_path__ + "img/intro-bg.6aaebbce.png";